import {
  type ExpenseStatusEnum,
  ExpenseStatuses,
} from '../../entities/enums/ExpenseStatusEnum'

export const mapExpenseStatusToUrl = (status?: ExpenseStatusEnum): string => {
  switch (status) {
    case ExpenseStatuses.PENDING:
      return 'pending'
    case ExpenseStatuses.APPROVED:
      return 'approved'
    case ExpenseStatuses.DENIED:
      return 'denied'
    default:
      return 'all'
  }
}
